let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("D1MVU")).then(() => parcelRequire('3CzqR'));